module.exports = __webpack_public_path__ + "media/images/footer_logo-d9e7e60a8ece8c9e60094953ecdebbaf.svg";